// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import "jquery"
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
require("@popperjs/core")

// import jquery from "jquery"
import "jquery"
import "bootstrap"
// Import the specific modules you may need (Modal, Alert, etc)
import "moment"
require('packs/bundles/libscripts.bundle');
require('packs/bundles/vendorscripts.bundle');
require('packs/bundles/mainscripts.bundle');
require('packs/bundles/morrisscripts.bundle.js');
require("packs/dashboard");
require("packs/admin");

Rails.start()
Turbolinks.start()
ActiveStorage.start()
